<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    List Customer Service
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <a v-on:click="toggleModal('new_cs')" class="btn px-15 btn-primary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Tambah Customer Service
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="csQuota == -1" class="alert alert-success" role="alert">
                <div class="alert-content">
                    <p>Batas customer service maksimal anda adalah <b>Unlimited</b> customer service</p>
                </div>
            </div>
            <div v-else-if="csQuota == 0" class="alert alert-danger" role="alert">
                <div class="alert-content">
                    <p>Batas customer service maksimal anda adalah <b>{{ csQuota }}</b> customer service</p>
                </div>
            </div>
            <div v-else class="alert alert-primary" role="alert">
                <div class="alert-content">
                    <p>Batas customer service maksimal anda adalah <b>{{ csQuota }}</b> customer service</p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <CustomerServiceTable />
                    </div>
                </div>
            </div>
            <modal name="new_cs" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddCS :device="device" />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import CustomerServiceTable from "@/components/tables/CustomerService.vue";
    import AddCS from "@/components/forms/cs/Add.vue";

    export default {
        components: {
            CustomerServiceTable,
            AddCS,
        },
        data() {
            return {
                device: [],
                exportJson: [],
                csQuota: 0
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
            
            this.csQuota = this.$store.state.auth.package.max_cs
            this.getDevice({ status: "all" })
        },
        methods: {
            toggleModal(param) {
                this.$modal.toggle(param);
            },
            async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices
            },
        },
    };
</script>